import statesJson from "./states.json";
import countriesJson from "./countries.json";

/* Add Constants here for example Reducer Constants eg */
export const HELLO_REQUEST = "HELLO_REQUEST";
export const HELLO_REQUEST_ERROR = "HELLO_REQUEST_ERROR";
export const HELLO_REQUEST_SUCCESS = "HELLO_REQUEST_SUCCESS";
export const states = statesJson;
export const countries = countriesJson;
export const orgFreeTrial = {
  dmp: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamed/free-trial",
  dmx: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamedex/free-trial",
};

export const freeTrialPlan = {
  id: 0,
  price: 0,
  description: "Free Trial",
};
